module.exports = "/dist/acee0ea9a8fefc488c5ba3f0cea449c2.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-100italic.woff2
// module id = 147
// module chunks = 0